<template>
  <div class="container-fluid init"> 

       <section id="proyecto-ahdeco-web" class="container my-5">

        <div class="row">
          <div class="col-lg-2 col-12 d-flex flex-column align-items-center order-lg-1 order-3 mt-3 mt-lg-0">

              <PhotoGalleryModal :images="galeria" />

              <div class="card border-0 shadow-sm rounded-2 mt-3">
                <div class="row g-3 small d-flex p-3 ">
                      <div class="col-12 col-md tec">
                        <strong>Tecnologías</strong><br>
                        Vue.js · JavaScript · HTML/CSS · Git
                      </div>
                      <div class="col-12 col-md tec">
                        <strong>Arquitectura</strong><br>
                        SPA · Rutas & componentes reutilizables
                      </div>
                      <div class="col-12 col-md tec">
                        <strong>Performance</strong><br>
                        Lazy loading · Code splitting
                      </div>
                      <div class="col-12 col-md tec">
                        <strong>Infra/DevOps</strong><br>
                        Linux · Nginx · Deploy productivo
                      </div>
                      <div class="col-12 col-md tec">
                        <strong>SEO Técnico</strong><br>
                        Metadatos, estructura semántica, accesibilidad
                      </div>
                    </div>
              </div>
              
          </div>
          <div class="col-12 col-lg-8 order-2 order-lg-2">
            
                <article class="card border-0 shadow-sm rounded-2">
                  <div class="card-body p-4 p-lg-5">
                    <h4 class="h3 mb-3 display-6 text-center">Sitio web corporativo AHDECO (Vue.js)</h4>
                    <img src="img/proyectos/ahdeco/1.png" alt="Proyecto AHDECO" class="img-fluid mb-3 rounded-1 shadow-sm">
                    <p class="mb-0">
                      Desarrollé el sitio web corporativo de AHDECO en Vue.js, estructurada con rutas y componentes reutilizables, diseño responsive y buenas prácticas de SEO técnico. Implementé la capa de presentación consumiendo endpoints disponibles, gestioné estado y navegación, apliqué optimizaciones de rendimiento (carga diferida, división de bundles) y realicé el despliegue en un entorno productivo basado en Linux con Nginx, versionando con Git. El resultado es un portal rápido, mantenible y alineado a la imagen institucional.
                    </p>

                    <hr class="my-4">
                    

                    <!-- Botón opcional a la demo o repositorio -->
                    <!-- <div class="mt-3">
                      <a href="#" class="btn btn-dark btn-sm rounded-3">Ver proyecto</a>
                    </div> -->
                  </div>
                </article>
     

          </div>
          <div class="col-12 col-lg-2 order-1 order-lg-3">
            <a class="btn btn-light" href="https://www.ahdecohn.org/" target="_blank">Ir a Sitio <i class="fa-solid fa-diamond-turn-right"></i></a>

          </div>
        </div>

  
</section>


  </div>
</template>

<script>
import PhotoGalleryModal from '../../PhotoGalleryModal.vue'

export default {
    name: 'ahdecoStatic',
    components: {
        PhotoGalleryModal
    },
    data() {
        return {
            galeria: [
                'img/proyectos/ahdeco/1.png',
                'img/proyectos/ahdeco/2.png',
                'img/proyectos/ahdeco/3.png',
                'img/proyectos/ahdeco/4.png',
                'img/proyectos/ahdeco/5.png',
                'img/proyectos/ahdeco/6.png',
                'img/proyectos/ahdeco/7.png',
                'img/proyectos/ahdeco/8.png',
                'img/proyectos/ahdeco/9.png',
                'img/proyectos/ahdeco/10.png',
                'img/proyectos/ahdeco/11.png',
                'img/proyectos/ahdeco/12.png',

            ]
        }
    },
}
</script>

<style scoped>
    .init {
        margin-top: 150px;
    }
    .tec {
      font-size: 0.8rem;
    }
</style>